import React, { useState } from "react";
import { Button, Icon } from "semantic-ui-react";
import { CustomerPickerModal } from "./CustomerPickerModal";
import "./Customers.scss";

// Botón "Selecciona un cliente" (o el cliente elegido, con × para quitarlo).
// Opcional: sin cliente, la venta sigue como siempre.
// `attention`: mientras no haya cliente, el botón se menea para que el mozo
// no se olvide de elegirlo (clase global .attention-button, AdminLayout.scss).
export function CustomerSelector(props) {
  const { customer, onChange, attention = false } = props;
  const [show, setShow] = useState(false);

  const select = async (selected) => {
    await onChange(selected);
    setShow(false);
  };

  return (
    <div className="customer-selector">
      {customer ? (
        <Button.Group basic size="small">
          <Button onClick={() => setShow(true)} title="Cambiar cliente">
            <Icon name="user" /> {customer.full_name}
            {customer.phone && <span className="customer-selector__detail"> · {customer.phone}</span>}
          </Button>
          <Button icon onClick={() => onChange(null)} title="Quitar cliente">
            <Icon name="close" />
          </Button>
        </Button.Group>
      ) : (
        <Button
          basic
          size="small"
          className={attention ? "attention-button" : undefined}
          onClick={() => setShow(true)}
        >
          <Icon name="user outline" /> Selecciona un cliente
        </Button>
      )}
      <CustomerPickerModal show={show} onClose={() => setShow(false)} onSelect={select} />
    </div>
  );
}
